const USER_INFO = 'user_info';
const ORIGIN_CD = 'origin_cd'; // for remember when login page
const PROVINCES = 'provinces';
const LOCALE = 'locale';
const DEIVERY_DEFAULT_VALUES = 'delivery_default_values';
const FCM_TOKEN = 'fcm_token';
const UX_CONFIG = 'ux_config';

export default {
  isLogin: () => localStorage.getItem(USER_INFO),

  saveUserInfo: (info) => {
    localStorage.setItem(ORIGIN_CD, info.user && info.user.origin_cd);
    localStorage.setItem(USER_INFO, JSON.stringify(info));
  },

  saveProvinces: (info) => {
    localStorage.setItem(PROVINCES, JSON.stringify(info));
  },

  getProvinces: () => {
    const data = localStorage.getItem(PROVINCES);
    return JSON.parse(data);
  },

  saveUxConfig: (info) => {
    localStorage.setItem(UX_CONFIG, JSON.stringify(info));
  },

  getUxConfig: () => {
    try {
      const data = localStorage.getItem(UX_CONFIG);
      return JSON.parse(data);
    } catch (err) {
      return {};
    }
  },

  getDeliveryDefaultValues: () => {
    const data = localStorage.getItem(DEIVERY_DEFAULT_VALUES);
    let parseData = JSON.parse(data);
    if (!parseData) {
      parseData = {};
    }
    return parseData;
  },

  setDeliveryDefaultValues: (info) => {
    localStorage.setItem(DEIVERY_DEFAULT_VALUES, JSON.stringify(info));
  },

  setFcmToken: (fcmToken) => {
    localStorage.setItem(FCM_TOKEN, fcmToken);
  },

  getFcmToken: () => {
    const data = localStorage.getItem(FCM_TOKEN);
    return data;
  },

  getOriginCD: () => {
    const data = localStorage.getItem(ORIGIN_CD);
    return data;
  },

  getUserInfo: () => {
    try {
      return JSON.parse(localStorage.getItem(USER_INFO));
    } catch (error) {
      console.log(error.message);
    }
    return null;
  },

  getUserRole: () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem(USER_INFO));
      return userInfo && userInfo.user.rolePermission;
    } catch (error) {
      console.log(error.message);
    }
    return null;
  },

  logout: () => {
    localStorage.removeItem(ORIGIN_CD);
    localStorage.removeItem(FCM_TOKEN);
    localStorage.removeItem(USER_INFO);
  },

  resetCache: () => {
    localStorage.removeItem(PROVINCES);
  },

  changeLocale: (value) => {
    localStorage.setItem(LOCALE, value);
  },

  getLocale: () => {
    const value = localStorage.getItem(LOCALE);
    return value || process.env.LOCALE_DEFAULT;
  },
};
